import useSWR from "swr";

export const fetcher = (url: string) => fetch(url, { credentials: "include" }).then((res) => res.json());

export default function useUser() {
	const { data, error } = useSWR("/api/auth/@me", fetcher, {
		focusThrottleInterval: 10000,
		dedupingInterval: 4000,
	});
	return {
		user: data,
		isLoading: !error && !data,
		isLoggedIn: data && !data.error,
		isError: error,
	};
}
